import { DependencyList, useEffect } from 'react'

export const useAsyncEffect = (asyncFunction: () => void, deps: DependencyList) => {
	return useEffect(() => {
		asyncFunction()
	}, deps)
}
